import { Resumen } from "src/app/models/PlanesUsuario/Resumen";

export class SaldoPagoUi {
	public static esConflicto(error: any): boolean {
		return Number(error?.status) === 409;
	}

	public static limpiarSeleccion(resumen: Resumen): void {
		if (!resumen) return;
		resumen.usarSaldoFavor = false;
		resumen.saldoAplicadoEsperado = 0;
	}

	public static esCoberturaTotal(data: any): boolean {
		return data?.pago === "saldo" && data?.completado === true;
	}
}
